import { Container, Row, Col, Nav } from "react-bootstrap";
import thankYouMAPImg from "../assets/img/mobileDAcademy.jpg";
//import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const ThankYouMAPurchase = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
        <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={thankYouMAPImg} alt="Thank You Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1><span className='quoteHeader'>Your Purchase</span> Was Successful.</h1>
                <h5 className="chris">Congratulations!</h5>
                <h4>Welcome to Totlesoft App Development Academy (TADA).</h4>
                  <p>
                    You just started partnering with one of the world best IT team.
                  </p><br />

                  <h3>TO GAIN ACCESS TO THE ACADEMY...</h3>
                  <p>Please check your <span className="chris">email</span> the one you entered into the form while making payment <span className="chris">you will see a message from Totlesoft containing a link to access the course. Thank you.</span></p>

                  <button>Please, also click below to:</button>
                  <Nav.Link href="https://chat.whatsapp.com/IS2gv9vdjx47xYoeXKxPqF"><h3>JOIN TADA SUPPORT GROUP</h3></Nav.Link><br />
                                    
                  <Nav.Link href="/academy"><h3>Return to Academy Home Page</h3></Nav.Link><br />
                  
            </div>}
            </TrackVisibility>
          </Col>
          </Row>
      </Container>
    </section>
  )
}
